// @ts-nocheck
import { ApiParameter, get, patch, post } from "@insite/client-framework/Services/ApiService";
import { BaseModel, ProductModel } from "@insite/client-framework/Types/ApiModels";
import { SndGrades, SndProduct } from "@store/Framework/Types/ApiModels";
import { FileInfo } from "@store/Library/Widgets/ScratchAndDent/ScratchAndDentForm";

const productsUrl = "/api/v2/products/";
const sndProductsUrl = "/api/v2/products/snd";

export interface GetSndProductsByParentSkuApiV2Parameter {
    id: string;
}
export interface GetProductBySndSkuApiV2Parameter {
    id: string;
}
export interface ScratchAndDentsProductParameter extends BaseModel {
    Grade: string;
    OriginalProductId: string;
    AdditionalDescription: string;
    SerialNumber: string;
    Status: string;
    ProductId: string;
    ActivateOn: string;
    Images: FileInfo[];
}

export interface UpdateScratchAndDentsProductApiParameter extends ApiParameter {
    sndProduct: ScratchAndDentsProductParameter;
}

export function getSndProductsByParentSku(parameter: GetSndProductsByParentSkuApiV2Parameter) {
    return get<ProductModel[]>(`${sndProductsUrl}/parent/${parameter.id}`);
}

export function getProductBySndSku(parameter: GetProductBySndSkuApiV2Parameter) {
    return get<ProductModel>(`${productsUrl}/${parameter.id}`);
}

export function getSndProductsAutoComplete() {
    return get<SndProduct[]>(`${sndProductsUrl}/all`);
}

export function getSndGrades() {
    return get<SndGrades>(`${sndProductsUrl}/getgrades`);
}

export function addSndProduct(sndProduct: ScratchAndDentsProductParameter) {
    return post<ScratchAndDentsProductParameter, string>(`${sndProductsUrl}/save`, {
        ...sndProduct,
    });
}

export function updateSndProduct(sndProduct: ScratchAndDentsProductParameter) {
    return patch(`${sndProductsUrl}/update`, {
        ...sndProduct,
    });
}
